import React, { useEffect, useState } from 'react'
import { useNewsTypeUpdateQuery } from '../../store/ReactWebSiteApi';
import { Descriptions,Spin } from 'antd';
import DocTitle from '../../cpn/DocTitle';
import NewsTypeEdit from './NewsTypeEdit';
function NewsTypeDesc(props) {
    const [info,setInfo] = useState({
        ent_name:''
    })
    const {data,isSuccess} = useNewsTypeUpdateQuery({ent_id:props.ent_id},{skip:!props.ent_id})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                console.log(data);                        
                setInfo({                                     
                    ent_ctime:data.Result.ent_ctime,                                       
                    ent_uname:data.Result.ent_uname,                                       
                    ent_riqi:data.Result.ent_riqi,                                                
                    ent_name:data.Result.ent_name,                                                
                    ent_content:data.Result.ent_content,                                                
                    ent_num:data.Result.ent_num,                                                 
                })
                // console.log(array);
                
            }
        }
    },[data, isSuccess])

    const items = [
        {
            key:'edit',
            label:'名称',
            children:info.ent_name,
            span:3
        },
        {
            key:'first',
            label:'备注',
            children:<div  
                        dangerouslySetInnerHTML={{__html:info.ent_content}}
                    />,
            span:3
        },
        {
            key:'7',
            label:'部门',
            children:<>{info.ent_dept_name}</>,
            labelStyle:{width:'120px'},
            contentStyle:{fontSize:"18px"}
        },
        {
            key:'8',
            label:'新增时间',
            children:info.ent_uname+info.ent_ctime,
            contentStyle:{fontSize:"18px"},
        },
        {
            key:'9',
            label:'操作',
            children:<><NewsTypeEdit ent_id={props.ent_id}/></>,
        },    
    ]
    return (
        <>
            {info.ent_ctime ? <div 
                                    style={{border:'2px solid #eee',margin:"10px",padding:'20px'}}
                                >
                                   <DocTitle
                                        name='新闻类型'
                                        num={props.ent_id}                    
                                    />                                    
                                    <Descriptions
                                        items={items}
                                        bordered
                                    />
                                </div>:  <Spin  size='large' />}
        </> 
    )
}

export default NewsTypeDesc